// extracted by mini-css-extract-plugin
export var emptyContent = "JmxSKSnaFszLEpg4bf8i";
export var emptyContentDescription = "TPwWHF47A8KSAjbv38Iw";
export var emptyContentHeading = "enHkbWN2xwuFswP9Triw";
export var header = "NRJwdB_6TAHmSvmSHaTp";
export var headerLink = "LV2VkEgVSFfBI4tl97So";
export var headerLinkChevron = "ROeDjPuH8IENvrb9pYPg";
export var headerLinkSkeleton = "bX7CReH2UNHka82_dg8x";
export var heading = "U99cwsSsYhQeM9cig1r9";
export var root = "vbJmPYwUxMmxrqlfNybr";